export default [
  {
    path: '/business-area',
    name: 'faciMana',
    component: () => import('Components/business/content/FaciMana'),
  },
  {
    path: '/business-area/logiMana',
    name: 'logiMana',
    component: () => import('Components/business/content/LogiMana'),
  },
  {
    path: '/business-area/secuMana',
    name: 'secuMana',
    component: () => import('Components/business/content/SecuMana'),
  },
  {
    path: '/business-area/admiMana',
    name: 'admiMana',
    component: () => import('Components/business/content/AdmiMana'),
  },
  {
    path: '/business-area/hotelMana',
    name: 'hotelMana',
    component: () => import('Components/business/content/HotelMana'),
  },
  {
    path: '/business-area/compMana',
    name: 'compMana',
    component: () => import('Components/business/content/CompMana'),
  },
]
